__turbopack_context__.v({
  "boldedText": "bEbASG_boldedText",
  "breachesCTAButton": "bEbASG_breachesCTAButton",
  "breachesEmphasis": "bEbASG_breachesEmphasis",
  "brokersEmphasis": "bEbASG_brokersEmphasis",
  "footerSection": "bEbASG_footerSection",
  "footerSectionCTA": "bEbASG_footerSectionCTA",
  "grayBG": "bEbASG_grayBG",
  "header": "bEbASG_header",
  "horizontalRule": "bEbASG_horizontalRule",
  "intro": "bEbASG_intro",
  "introCTA": "bEbASG_introCTA",
  "introContent": "bEbASG_introContent",
  "note": "bEbASG_note",
  "privateInfoRow": "bEbASG_privateInfoRow",
  "privateInfoText": "bEbASG_privateInfoText",
  "reversedStep": "bEbASG_reversedStep",
  "sectionCTAButton": "bEbASG_sectionCTAButton",
  "sectionWrapper": "bEbASG_sectionWrapper",
  "step": "bEbASG_step",
  "stepBody": "bEbASG_stepBody",
  "stepGroupTitleAfter1st": "bEbASG_stepGroupTitleAfter1st",
  "stepSubtitle": "bEbASG_stepSubtitle",
  "stepTextContainer": "bEbASG_stepTextContainer",
  "stepTitle": "bEbASG_stepTitle",
  "title": "bEbASG_title",
});
